var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileVine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m45.26,17.84c32.63,-11.58 48.95,7.89 64.74,30c15.79,22.11 54.74,52.63 93.68,63.16c38.95,10.53 74.21,14.74 90,-2.63c15.79,-17.37 9.47,-71.05 -47.89,-83.16c-57.37,-12.11 -131.58,-10.53 -154.21,55.79c-22.63,66.32 11.05,172.63 61.05,152.63c50,-20 115.79,-25.26 107.37,98.47c-8.42,123.74 52.11,134.68 39.47,182.63c-12.63,47.95 -130.53,33.11 -175.26,15.79c-44.74,-17.32 -107.37,-32.68 -96.32,-96.84c11.05,-64.16 116.32,-4.79 121.05,-62.16c4.74,-57.37 -62.11,-46.84 -94.21,-91.53c-32.11,-44.68 -43.16,-97.95 -41.05,-145.26c2.11,-47.32 -1.05,-105.32 31.58,-116.89z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_4",
    stroke: "#f90000",
    strokeWidth: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVine1);
export default __webpack_public_path__ + "static/media/mobileVine1.da731c69e651f34b893668d8869a591c.svg";
export { ForwardRef as ReactComponent };